import { gql, gqlClient } from '@/services/gql';

export async function loginAsUser({ state, commit }, user) {
  return await state.service.loginAsUser(user);
}

export async function removeRecentUser({ state, dispatch }, user) {
  state.service.removeRecentUser(user);
  await dispatch('fetchRecent');
}

export async function clearRecentUsers({ state, commit }) {
  state.service.clearRecentUsers();
  commit('SET_RECENT_USERS', []);
}

export async function clearFavoriteUsers({ state, commit }) {
  state.service.clearFavoriteUsers();
  commit('SET_FAVORITE_USERS', []);
}

export async function favoriteUser({ state, dispatch }, user) {
  await state.service.favoriteUser(user);
  await dispatch('fetchFavorites');
}

export async function removeFavoriteUser({ state, dispatch }, user) {
  state.service.removeFavoriteUser(user);
  await dispatch('fetchFavorites');
}

export async function importFavoriteUsers({ state, dispatch }, options) {
  await state.service.importFavoriteUsers(
    JSON.parse(options.data),
    options.replace
  );
  await dispatch('fetchFavorites');
}

const QUERY = gql`
  query ($ids: Mixed!) {
    devToolsLogin(ids: $ids) {
      data {
        id
        firstName
        lastName
        profileImageUrl
        userType
        refType
        gender
        player {
          isExpired
        }
        site {
          sportName
        }
      }
    }
  }
`;

export async function fetchRecent({ state, commit }) {
  const ids = state.service.getRecentUsers();
  const response = await gqlClient.query(QUERY, {
    ids: ids
  });

  commit(
      'SET_RECENT_USERS',
      response.devToolsLogin.data.sort((a, b) => {
        const keyA = ids.indexOf(a.id);
        const keyB = ids.indexOf(b.id);

        return keyA - keyB;
      })
  );
}

export async function fetchFavorites({ state, commit }) {
  const ids = state.service.getFavoriteUsers();
  const response = await gqlClient.query(QUERY, {
    ids: ids
  });

  commit(
      'SET_FAVORITE_USERS',
      response.devToolsLogin.data.sort((a, b) => {
        const keyA = ids.indexOf(a.id);
        const keyB = ids.indexOf(b.id);

        return keyA - keyB;
      })
  );
}

export async function getAuthenticatedUser({ commit }) {
  const QUERY = gql`
      query {
          me {
              id
              firstName
              lastName
              profileImageUrl
              userType
              refType
              gender
              player {
                  isExpired
              }
              site {
                  sportName
              }
          }
      }`;

  const response = await gqlClient.query(QUERY);

  commit('SET_AUTHENTICATED_USER', response.me);
}

export async function getOpsToggles({ commit }) {
  const QUERY = gql`
      query {
          opsToggles {
              id
              name
              enabled
          }
      }`;

  const response = await gqlClient.query(QUERY);

  commit('SET_OPS_TOGGLES', response.opsToggles);
}

export async function updateOpsToggle({ commit }, { id, enabled }) {
  const MUTATION = gql`
      mutation ($id: ID!, $enabled: Boolean!) {
          updateOpsToggle(id: $id, enabled: $enabled) {
              id
              name
              enabled
          }
      }`;

  const response = await gqlClient.query(MUTATION, {
    id,
    enabled
  });
}